import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import { ESG_ALERTS } from './esgData';

const SEVERITY_CONFIG = {
  High: { bg: '#fee2e2', text: '#dc2626', border: '#fca5a5', icon: 'AlertCircle' },
  Medium: { bg: '#fef3c7', text: '#b45309', border: '#fcd34d', icon: 'AlertTriangle' },
  Low: { bg: '#dbeafe', text: '#1d4ed8', border: '#93c5fd', icon: 'Info' },
};

export default function ESGAlertsPanel({ onToast }) {
  const [alerts, setAlerts] = useState(ESG_ALERTS);

  const handleAcknowledge = (id) => {
    setAlerts((prev) => prev?.map((a) => a?.id === id ? { ...a, acknowledged: true } : a));
    onToast?.('Alert acknowledged — action recorded.');
  };

  const active = alerts?.filter((a) => !a?.acknowledged);
  const acknowledged = alerts?.filter((a) => a?.acknowledged);

  return (
    <div className="card" style={{ padding: '20px 24px' }}>
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="font-heading font-semibold text-foreground" style={{ fontSize: '0.9375rem' }}>ESG Alerts</h3>
          <p className="font-caption text-muted-foreground text-xs mt-0.5">{active?.length} active alert{active?.length !== 1 ? 's' : ''} requiring attention</p>
        </div>
        {active?.length > 0 && (
          <span className="inline-flex items-center justify-center w-6 h-6 rounded-full font-caption text-xs font-bold text-white" style={{ background: '#dc2626' }}>
            {active?.length}
          </span>
        )}
      </div>
      <div className="space-y-3">
        {active?.map((alert) => {
          const cfg = SEVERITY_CONFIG?.[alert?.severity] || SEVERITY_CONFIG?.Low;
          return (
            <div key={alert?.id} className="rounded-xl border p-4" style={{ borderColor: cfg?.border, background: cfg?.bg + '60' }}>
              <div className="flex items-start justify-between gap-3">
                <div className="flex items-start gap-3 flex-1 min-w-0">
                  <Icon name={cfg?.icon} size={16} color={cfg?.text} className="flex-shrink-0 mt-0.5" />
                  <div className="min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="inline-flex items-center px-2 py-0.5 rounded-full font-caption text-xs font-semibold" style={{ background: cfg?.bg, color: cfg?.text }}>
                        {alert?.severity}
                      </span>
                      <span className="font-caption text-xs font-semibold text-foreground">{alert?.asset}</span>
                      <span className="font-caption text-xs text-muted-foreground">· {alert?.metric}</span>
                    </div>
                    <p className="font-caption text-sm text-foreground mt-1.5" style={{ lineHeight: 1.5 }}>{alert?.description}</p>
                    <p className="font-caption text-xs text-muted-foreground mt-1">Raised {alert?.date}</p>
                  </div>
                </div>
                <button
                  onClick={() => handleAcknowledge(alert?.id)}
                  className="flex-shrink-0 px-3 py-1.5 rounded-lg border font-caption text-xs font-medium transition-all hover:bg-card"
                  style={{ borderColor: cfg?.border, color: cfg?.text }}
                >
                  Acknowledge
                </button>
              </div>
            </div>
          );
        })}

        {acknowledged?.length > 0 && (
          <div className="pt-2 border-t border-border">
            <p className="font-caption text-xs text-muted-foreground mb-2">{acknowledged?.length} acknowledged</p>
            {acknowledged?.map((alert) => (
              <div key={alert?.id} className="flex items-center gap-2 py-1.5">
                <Icon name="CheckCircle" size={13} color="#16a34a" />
                <span className="font-caption text-xs text-muted-foreground line-through">{alert?.asset} — {alert?.metric}</span>
              </div>
            ))}
          </div>
        )}

        {active?.length === 0 && acknowledged?.length === 0 && (
          <div className="text-center py-6">
            <Icon name="CheckCircle" size={32} color="#16a34a" />
            <p className="font-caption text-sm text-muted-foreground mt-2">No active ESG alerts</p>
          </div>
        )}
      </div>
    </div>
  );
}
